<script lang="ts">
    import UserModal from "../components/UserModal.svelte";
    import { v4 as uuidv4 } from 'uuid';
    import { User } from '../Model/User';
    import { usersService } from "../services";
    import { Button } from "sveltestrap";
    import AppWraper from "../components/AppWraper.svelte";

    export let editUser = null;

    let users: User[];
    
    let offset = 0;
    let limit = 25;

    // const dispatch = createEventDispatcher();

    load()

    async function load(){

        let opts = {
            offset : offset,
            limit : limit
        }

        users = await usersService.findUsers(opts);

        users.sort((a,b) => {
            return a.name < b.name ? -1 : 1;
        })
        
    }

    function userUpdate(user: User): void {
        let userAct = users.find(u => u.id == user.id)

        if (userAct) {
            userAct = user
            users = users;
        }else{
            users = [...users, user];
        }
    }

    function newUser(){

        editUser = new User({
		    id: uuidv4(),
            photo: null,
            sign: null,
			access_token: uuidv4(),
			status: true,
			enabled: true,
			removed: false,
			type: null,
            signer: false,
            cargo: '',
			name: '',
            surname1: '',
            surname2: '',
            dni: '',
            position_id: '',
            agent_id: '',
            municipality_id: '',
            is_agent: false,
			phone: '',
			email: '',
			password: '',
			image: '',
			date_created: '',
			date_updated: '',
			date_last_login: '',
			date_removed: ''
		});
		
	}

</script>

<style>

</style>


<AppWraper>
    <div class="container-fluid p-5">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-9 mb-3">
                    <div class="text-start">
                        <h3>Listado de Usuarios</h3>
                    </div>
                  </div>
              <div class="col-12 col-sm-3 mb-3">
                <div class="text-end">
                    <Button color="primary" on:click={() => newUser()}>
                        Nuevo usuario
                    </Button>
                </div>
              </div>
              <div class="col">
                {#if users?.length}
                <table class="table">
                    <thead>
                            <tr>
                                <th scope="col"></th>
                                <th scope="col">Nombre</th>
                                <th scope="col">Email</th>
                                <th scope="col">Tipo</th>
                            </tr>
                
                    </thead>
                    <tbody>
                        {#each users as user, index }
                            <tr>
                                <th scope="row">{index + 1}</th>
                                <td><span class="btn btn-link" on:click={() => editUser = user}>{user.name}</span></td>
                                <td>{user.email}</td>
                                <td>{user.type.name}</td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            {:else}
                <div class="text-center pt-5">
                    <hr>
                    <h3>No hay usuarios para mostrar</h3>
                </div>
            {/if}
              </div>
            </div>
        </div>
    </div>
</AppWraper>


<UserModal user={editUser}  on:userUpdate={() => userUpdate(editUser)}/>


